
        import 'PhoneNumberInput.3909f57.css-module'
        export default {"phoneContainer":"phoneContainer_PhoneNumberInput_3909f57","input":"input_PhoneNumberInput_3909f57","flag":"flag_PhoneNumberInput_3909f57"}
    